import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1123c808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "processed-files-displayer relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "processed-files-displayer-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Projede Yer Alan Dosyalar")
], -1))
const _hoisted_3 = { class: "processed-files-displayer-content" }

import { useStore } from 'vuex';
import { computed } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'processedFilesDisplayer',
  setup(__props) {

const store = useStore()
const selectedProject = computed(() => store.getters['ai/selectedProject']);
const processedFiles = computed(() => selectedProject.value.processedFiles);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedFiles.value, (file) => {
        return (_openBlock(), _createElementBlock("li", {
          key: file.id
        }, _toDisplayString(file.name), 1))
      }), 128))
    ])
  ]))
}
}

})